import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { UniversalIntegrationsHero } from './components/Hero'
import { UniversalIntegrationsDataModels } from './components/DataModels'
import { UniversalIntegrationsApply } from './components/Apply'
import { UniversalIntegrationsCreate } from './components/Create'
import { UniversalIntegrationsActions } from './components/Actions'
import classes from './UniversalIntegrations.module.scss'

export default function UniversalIntegrationsPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'Universal Integrations'} />
      <Container>
        <UniversalIntegrationsHero />
        <UniversalIntegrationsDataModels />
        <UniversalIntegrationsApply />
        <UniversalIntegrationsCreate />
        <UniversalIntegrationsActions />
      </Container>
    </DefaultPageLayout>
  )
}
